export default __webpack_public_path__ + "static/media/NH006.ab6bb47b.jpg";